// autogenerated, do not modify

export default {
  "ActivationCode.AlreadyHasCards": "It looks like you already have an account. Please login",
  "ActivationCode.ButtonText": "下一步",
  "ActivationCode.FieldsAreRequired": "字段为必填",
  "ActivationCode.FindActivationCode": "在您的MTXC SIM卡背面可以找到激活号码:",
  "ActivationCode.Header": "激活码",
  "ActivationCode.Placeholder": "输入激活号码",
  "ActivationCode.WrongFormat": "激活码无效",
  "Axios.ConnectionError": "没有联网。请检查您的联网设置以及APN（接入点）的设置（您需要将APN设为“internet”)。",
  "Axios.Error": "错误 {status}。",
  "Axios.ServerError": "系统错误。我们正努力解决这个问题。请稍后重试。",
  "Axios.TimeoutError": "服务器超时。请稍后重试。",
  "Common.ActivationCode": "激活码",
  "Common.Back": "返回",
  "Common.Email": "电子邮件",
  "Common.Name": "姓名",
  "Common.Next": "下一步",
  "Common.Password": "密码",
  "Common.Phone": "电话",
  "Common.SIM": "SIM",
  "Confirmation.ActivateMySim": "激活我的SIM卡",
  "Confirmation.Header": "请确认您的详细信息",
  "ForgotPassword.BackToLogin": "返回“登录”页面",
  "ForgotPassword.ButtonText": "发送恢复代码",
  "ForgotPassword.ChangePassword": "设置新密码",
  "ForgotPassword.CheckYourEmailOrPhone": "请检查您的电子邮件，查看新密码。",
  "ForgotPassword.CheckYourPhone": "请检查您的手机短信，查看新密码。",
  "ForgotPassword.EnterEmailOrPhone": "请输入您的email地址",
  "ForgotPassword.EnterNewPassword": "请设定您的新密码",
  "ForgotPassword.EnterPhone": "请输入您的手机号码",
  "ForgotPassword.Header": "密码恢复",
  "ForgotPassword.NewPassword": "新密码",
  "ForgotPassword.NewPasswordConfirmation": "确认密码",
  "ForgotPassword.PasswordAreTooWeak": "密码安全性太低。请设置安全性高的密码！",
  "ForgotPassword.PasswordChanged": "密码修改成功！",
  "ForgotPassword.PasswordsDoesNotMatch": "密码不匹配",
  "ForgotPassword.RecoveryTokenInvalid": "您的密码重置链接已过期。请重新设置密码。",
  "ForgotPassword.ScoreWord-good": "安全性好",
  "ForgotPassword.ScoreWord-okay": "安全性中等",
  "ForgotPassword.ScoreWord-strong": "安全性高",
  "ForgotPassword.ScoreWord-stronger": "安全性更高",
  "ForgotPassword.ScoreWord-weak": "安全性低",
  "ForgotPassword.TryAgain": "重置密码",
  "ForgotPassword.UnableToChangePassword": "无法修改密码！请重新开始。",
  "Login.ActivateCard": "开始使用SIM卡",
  "Login.AlreadyHaveAccount": "您已经有一个帐户。请登录。",
  "Login.ForgotPassword": "忘记密码",
  "Login.Header": "登录",
  "Login.Login": "登录",
  "Login.Or": "或",
  "Login.Signup": "注册",
  "Login.TryLogin": "请登录，若无账号则请注册。",
  "Menu.ContactUs": "联系我们",
  "Menu.Coverage": "覆盖区域",
  "Menu.Faq": "常见问题",
  "Menu.HowItWorks": "如何使用",
  "Menu.Pricing": "价格",
  "Register.AlreadyHaveAccount": "已有帐户？",
  "Register.ButtonText": "注册",
  "Register.ChooseFile": "选择一个文件",
  "Register.ConfirmEmail": "确认Email",
  "Register.ConfirmPassword": "确认密码",
  "Register.ConfirmPhone": "确认电话号码",
  "Register.Country": "国家",
  "Register.Email": "电子邮件",
  "Register.EmailWrongFormat": "Email不正确",
  "Register.EmailsDontMatch": "Email不匹配",
  "Register.FirstName": "名",
  "Register.FirstNameHint": null,
  "Register.Header": "请提供您的详细信息",
  "Register.IdentityHint": "(您可以稍后操作)",
  "Register.LastName": "姓",
  "Register.LastNameHint": null,
  "Register.NonLatinError": "仅限于拉丁字母、数字及标点符号",
  "Register.Password": "密码",
  "Register.PasswordsDontMatch": "密码不匹配",
  "Register.Phone": "电话号码",
  "Register.PhoneHint": null,
  "Register.PhonesDontMatch": "电话号码不匹配",
  "Register.ShortPassword": "密码太短",
  "Register.ShouldAgreeWithTerms": "您需要同意使用条款",
  "Register.TermsAndConditions": "若继续操作，您必须阅读并接受MTX Connect的条款",
  "Register.UploadIdentity": "上传身份证件的扫描件",
  "Register.UploadWrongFormat": "文档应是 jpg 格式",
  "Register.countryEmpty": "国家必选",
  "Register.emailEmpty": "Email是必需的",
  "Register.firstNameEmpty": "名是必需的",
  "Register.lastNameEmpty": "姓是必需的",
  "Register.passwordEmpty": "密码是必需的",
  "Register.phoneEmpty": "“电话号码”为必填",
  "Shared.ErrorPhoneMsg": "仅限于拉丁字母、数字及标点符号",
  "Verify.Title": "谢谢您！您的电子邮件地址已被确认。",
}



// WEBPACK FOOTER //
// ./app/javascript/components/application/locales/zh.js